import { EventTypeIdentifier } from '../enums/eventTypeIdentifier';
import { Event } from '../interfaces';

export const getBlockName = (event: Event, raw = false): string => {
  if (event.event_type_identifier === EventTypeIdentifier.ROADWORKS) {
    return 'N/A';
  }

  if (raw) {
    return event?.metadata?.route_metadata?.block_name || '-';
  }

  const dir = event?.metadata?.route_metadata?.route_direction;
  const block_name = event?.metadata?.route_metadata?.block_name;
  const block_id = event?.metadata?.route_metadata?.block_id;

  let str = `${dir} ${block_name}`;

  if (!event?.metadata?.route_metadata) {
    return '-';
  }

  if (
    block_id &&
    (event.event_type_identifier === EventTypeIdentifier.BUS_STOP ||
      event.event_type_identifier === EventTypeIdentifier.BUS_STOP_MATCH ||
      event.event_type_identifier === EventTypeIdentifier.BUS_STOP_PARKING)
  ) {
    if (!dir.includes(block_id)) {
      str += ` [#${block_id}]`;
    }
  }

  return str;
};
